// Copyright (c) 2019 Deere & Company

import { createErrorMessage } from '../action-creator/alert-messages';
import store from '../../store';

const DEFAULT_ERROR_MESSAGE = 'UNABLE_TO_CONTACT_THE_SERVER';

const getErrorMessage = value => {
    if ( typeof value === 'string' && value.trim() ) {
        return value;
    }

    return DEFAULT_ERROR_MESSAGE;
};

export const errorAlertBar = errorObject => {

    const { dispatch } = store;
    let { message } = errorObject;
    const { messages } = errorObject;

    if ( messages ) {

        messages.forEach( element => {

            message = getErrorMessage( element && element.message );
            dispatch( createErrorMessage( message ) );

        } );

    } else if ( message ) {

        dispatch( createErrorMessage( getErrorMessage( message ) ) );


    } else {

        dispatch( createErrorMessage( DEFAULT_ERROR_MESSAGE ) );

    }

};
